module.exports = __webpack_public_path__ + "static/assets/19c08df01b65eb057f17ff4f68be34f0.svg";